// noinspection JSUnresolvedVariable,JSUnresolvedFunction

import Kernel from "@oilstone/kernel";
import { useState } from "vue-gtag-next";

const state = {
    analytics: false,
    marketing: false,
    cookiePromptVisible: false,
    settingsDialogueVisible: false,
    hasCookiePreference: false
};

const getters = {
    getAnalytics: state => {
        return state.analytics;
    },

    getMarketing: state => {
        return state.marketing;
    },

    getPreferences: state => {
        return {
            analytics: state.analytics,
            marketing: state.marketing,
        };
    },

    getCookiePromptVisibility: state => {
        return state.cookiePromptVisible;
    },

    getSettingsDialogueVisibility: state => {
        return state.settingsDialogueVisible;
    },

    shouldShowCookiePrompt: state => {
        return !state.hasCookiePreference;
    },
};

const mutations = {
    SET_ANALYTICS(state, analytics) {
        state.analytics = analytics;
    },

    SET_MARKETING(state, marketing) {
        state.marketing = marketing;
    },

    SET_PREFERENCES(state, {analytics, marketing}) {
        if (typeof analytics !== 'undefined') {
            state.analytics = analytics;
        }

        if (typeof marketing !== 'undefined') {
            state.marketing = marketing;
        }
    },

    SET_COOKIE_PROMPT_VISIBILITY(state, visible) {
        state.cookiePromptVisible = visible;
    },

    SET_SETTINGS_DIALOGUE_VISIBILITY(state, visible) {
        state.settingsDialogueVisible = visible;
    },

    SET_HAS_COOKIE_PREFERENCE(state, hasPreference) {
        state.hasCookiePreference = hasPreference;
    },
}

const actions = {
    setAnalytics({commit}, value) {
        commit('SET_ANALYTICS', value);
    },

    setMarketing({commit}, value) {
        commit('SET_MARKETING', value);
    },

    setHasCookiePreference({commit}, value) {
        commit('SET_HAS_COOKIE_PREFERENCE', value);
    },

    setPreference({commit, dispatch}, {preference, isGranted}) {
        const set = {};

        set[preference] = isGranted;

        commit('SET_PREFERENCES', set);

        return dispatch('savePreferences');
    },

    acceptAll({commit, dispatch}) {
        commit('SET_PREFERENCES', {
            analytics: true,
            marketing: true,
        });

        return dispatch('savePreferences');
    },

    updateGtag({state}) {
        const { isEnabled } = useState();

        if (state.analytics) {
            isEnabled.value = true;
        } else {
            isEnabled.value = false;
        }
    },

    savePreferences({dispatch}) {
        return dispatch('updateCookie').then(() => {
            return dispatch('setHasCookiePreference', true).then(() => {
                dispatch('updateGtag').then(() => {
                    const { isEnabled } = useState();

                    if (!isEnabled.value) {
                        //plugin does not seem to stop tracking so we must reload the page :(
                        location.reload();
                    }
                })
            });
        });
    },

    updateCookie({getters}) {
        const cookie = Kernel.resolve('cookie');

        if (cookie) {
            cookie.set('cookieConsent', JSON.stringify(getters.getPreferences), {expires: 365}); // Expire in 1 year
        }
    },

    showCookiePrompt({commit}) {
        commit('SET_COOKIE_PROMPT_VISIBILITY', true);
    },

    hideCookiePrompt({commit}) {
        commit('SET_COOKIE_PROMPT_VISIBILITY', false);
    },

    showCookieSettings({commit}) {
        commit('SET_SETTINGS_DIALOGUE_VISIBILITY', true);
    },

    hideCookieSettings({commit}) {
        commit('SET_SETTINGS_DIALOGUE_VISIBILITY', false);
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
